"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgLeafOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6.664 16.825A8 8 0 0113.046 4H18a3.044 3.044 0 013.045 3.045V12A8 8 0 018.06 18.257l-.88.87a5.904 5.904 0 01-4.154 1.712H3a1 1 0 110-2h.027a3.904 3.904 0 002.747-1.132l.89-.882zM18.61 12a5.563 5.563 0 01-8.799 4.526l1.595-1.576 3.581.05a1 1 0 10.028-2l-1.612-.022 2.8-2.766a1 1 0 10-1.405-1.424L12 11.551V10a1 1 0 10-2 0v3.527L8.419 15.09a5.563 5.563 0 014.627-8.653H18c.336 0 .608.272.608.608V12z' }))); };
exports.default = SvgLeafOutline;
//# sourceMappingURL=LeafOutline.js.map